import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ModalHeading from '../ModalHeading';
import SaveOrCancel from '../SaveOrCancel';
import { AlertJsMessage } from '../../helpers';

const defaultFormData = {
  rounds: 1,
  amrp: false,
  emom: false
}

export class EditPlanModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      circuitType: 'rounds',
      itemId: 0,
      formData: {

      }
    }
  }

  componentDidUpdate() {
    if (this.props.item) {
      if (this.state.itemId !== this.props.item.id) {
        this.setFormData();
      }
    }
  }

  setFormData() {
    const { item } = this.props;
    if (item.planData) {
      this.setState({
        formData: {
          ...item.planData
        }
      })
    } else {
      let circuitType;
      let formData;
      if (item.formData) {
        const { amrp, emom, rounds } = item.formData
        circuitType =  amrp > 0 ? 'amrp': 
                        emom > 0 ? 'emom' : 'rounds'
        formData = item.formData;
      } else {
        circuitType = 'rounds';
        formData = defaultFormData;
      }
    
      this.setState({
        itemId: item.id ? item.id : -1,
        circuitType,
        formData: {
          ...formData
        }
      })
    }
  }

  handleCheckboxChange = (field) => event => {
    this.setState({ field: event.target.value });
  }

  handleChange = field => event => {
    if (event.target) {
      this.setState({
        formData: {
          amrp: 0,
          rounds: 0,
          emom: 0,
          [field]: parseInt(event.target.value)
        }
      })
    }
  }

  validate() {
    const { save } = this.props;
    const { formData, circuitType } = this.state;
    formData.rounds = parseInt(formData.rounds, 0);
    if (circuitType === 'rounds' && formData.rounds < 1) {
      AlertJsMessage("Please provide a number greater than 0 for rounds.");
    } else if (circuitType === 'emom' && formData.emom < 1) {
      AlertJsMessage("Please provide a number greater than 0 for EMOM.");
    } else if (circuitType === 'amrp' && formData.amrp < 1) {
      AlertJsMessage("Please provide a number greater than 0 for AMRP.");
    } else {
      save(formData);
    }
  }

  handleCircuitType = (event, type) => {
    if (type) {
      this.setState({
        circuitType: type,
        formData: {
          ...this.state.formData,
          amrp: 0,
          rounds: 0,
          emom: 0
        }
      })
    }
  }

  onModalClose = () => {
    const { item, remove, close } = this.props;
    if (!item.isEdit) {
      remove();
      close();
    } else {
      close();
    }
  }

  render() {
    const { item } = this.props;
    const { formData, circuitType } = this.state;
    if (item) {
      if (item.type === 'circuit' && item.child) {
        return (
          <Modal
            className="modal show"
            open={item.child ? true : false}
            onClose={this.onModalClose}
          >
            <div className="modalBody modal-content" style={{ width: 440 }}>
              <ModalHeading
                text="EDIT CIRCUIT"
                closeModal={this.onModalClose}
              />
              <div className="modalContent">
                <div>
                  <ToggleButtonGroup value={circuitType}
                    onChange={this.handleCircuitType} exclusive>
                    <ToggleButton
                      style={{ marginRight: 10 }}
                      value='rounds' selected={circuitType === 'rounds'}>
                      Rounds
                    </ToggleButton>
                    <ToggleButton
                      value="amrp"
                      selected={circuitType === 'amrp'}
                      style={{ marginRight: 10 }}
                    >
                      As Many Rounds As Possible
                    </ToggleButton>
                    <ToggleButton
                      value="emom"
                      selected={circuitType === 'emom'}>
                      EMOM
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
                <div style={{ marginTop: 22, width: 215 }}>
                  {
                    circuitType === 'rounds' ? (
                      <TextField
                        label='Number of Rounds'
                        value={formData.rounds}
                        onChange={this.handleChange('rounds')}
                        margin="dense"
                        variant="outlined"
                        type="number"
                      />
                    ) : null
                  }
                  {
                    circuitType === 'amrp' ? (
                      <TextField
                        label='Duration in Minutes of AMRP'
                        value={formData.amrp}
                        onChange={this.handleChange('amrp')}
                        margin="dense"
                        variant="outlined"
                        type="number"
                      />
                    ) : null
                  }
                  {
                    circuitType === 'emom' ? (
                      <TextField
                        label='Number of Rounds'
                        value={formData.emom}
                        onChange={this.handleChange('emom')}
                        margin="dense"
                        variant="outlined"
                        type="number"
                      />
                    ) : null
                  }

                </div>
                <div style={{ marginTop: 14 }}>
                  <SaveOrCancel
                    onSaveClick={() => this.validate()}
                    onCancelClick={this.onModalClose}
                  />
                </div>
              </div>
            </div>
          </Modal>
        )
      }
    }
    return null;
  }
}
export default EditPlanModal;



// WEBPACK FOOTER //
// ./src/components/workouts/EditCircuitModal.js